<template>
<div class="content-body tenant-settings">
    <!-- <div class="" style="background: red ;display: none"> -->
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <!-- <el-form-item label="工厂:">
                <el-input size="small" v-model="dataForm.werks" placeholder="工厂" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <el-form-item label="工厂名称:">
                <el-select v-model="dataForm.name2" clearable filterable placeholder="请选择工厂" @change="setFactoryName">
                    <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商名称:">
                <el-input size="small" v-model="dataForm.name1" placeholder="供应商名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="物料编码:">
                <el-input size="small" v-model="dataForm.matnr" placeholder="物料编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="需求日期:">
                  <el-date-picker
                    v-model="dataForm.demandDate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @blur="getDataList"
                    value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" type="primary" @click="exportData()">
                    导出
                </el-button>
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建项目
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-upload2">
                    导入项目
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :header-cell-style="{background:'#f5f5f5'}" border :data="dataList" row-key="id" size="mini" style="width: 100%;" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="name2" header-align="center" align="left" label="工厂名称">
                    <!-- <template slot-scope="scope">
                        <span>{{scope.row.name2}}</span>
                    </template> -->
                </el-table-column>
                <el-table-column prop="werks" header-align="center" align="left" label="工厂">
                </el-table-column>
                <el-table-column prop="lifnr" header-align="center" align="left" label="供应商">
                </el-table-column>
                <el-table-column prop="name1" header-align="center" align="left" label="供应商名称">
                </el-table-column>
                <el-table-column prop="matnr" header-align="center" align="left" label="物料编码">
                </el-table-column>
                <el-table-column prop="maktx" header-align="center" align="left" label="物料描述">
                </el-table-column>
                <el-table-column prop="meins" header-align="center" align="center" label="单位">
                    <template slot-scope="scope">
                        <span>{{getUnitName(scope.row.meins)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="budat" header-align="center" align="right" label="需求日期" :formatter="dateFormatNew" width="170">
                </el-table-column>
                <el-table-column prop="menge" header-align="center" align="right" label="需求数量">
                </el-table-column>
                <el-table-column prop="zfbrq" header-align="center" align="right" label="发布日期" :formatter="dateFormatNew" width="170">
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    getDayPlanList,
    removeDayPlan,
    exportDayPlanData
    // list
} from '@/controller/sap'
import {
    getFactoryList,
    getUnitList
} from '@/controller/systemData'
import AddOrUpdate from './day-plan-add-or-update'
import moment from 'moment'
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                zfbrq: '',
                werks: '',
                name2: '',
                lifnr: '',
                name1: '',
                matnr: '',
                maktx: '',
                budat: '',
                menge: '',
                meins: '',
                demandDate: ''
            },
            dataList: [],
            unitList: [],
            tenantList: [],
            factoryList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },

    components: {
        AddOrUpdate
    },
    activated() {
        this.getDataList()
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        dateFormatNew: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        exportData() {
            this.getFactoryList()
            const demandDate = []
            if(this.dataForm.demandDate == '' || this.dataForm.demandDate == null) {
                this.$message.error("请选择需求日期");
                return
            }
            this.dataForm.demandDate.forEach(date => {
                demandDate.push(date)
            });
            exportDayPlanData({
                'werks': this.dataForm.werks,
                'supplierName': this.dataForm.name2,
                'partCode': this.dataForm.matnr,
                demandDate: demandDate
            }).then((data) => {
                if(data && data.code == '00') {
                    this.readAsBinaryString(data.body)
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500
                    })
                } else {
                    this.$message.error(data.msg)
                }
            }).catch((e) => {
                this.$message.error(e)
            })
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            this.getFactoryList()
            const demandDate = []
            if(this.dataForm.demandDate != '' && this.dataForm.demandDate) {
                this.dataForm.demandDate.forEach(date => {
                    demandDate.push(date)
                });
            }
            getDayPlanList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'zfbrq': this.dataForm.zfbrq,
                'werks': this.dataForm.werks,
                'name2': this.dataForm.name2,
                'lifnr': this.dataForm.lifnr,
                'name1': this.dataForm.name1,
                'matnr': this.dataForm.matnr,
                'maktx': this.dataForm.maktx,
                'budat': this.dataForm.budat,
                'menge': this.dataForm.menge,
                'meins': this.dataForm.meins,
                demandDate: demandDate
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
            this.getUnitList()
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeDayPlan({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.factoryDesc = ""
            })
        },
        setFactoryName(val) {
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            this.dataForm.name2 = factory ? factory.factoryDesc : ''
        },
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        readAsBinaryString(data) {
            // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
            // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
        },
        str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
        }
    }
}
</script>
